import { render, staticRenderFns } from "./inventory-reports.vue?vue&type=template&id=ad6341a4"
import script from "./inventory-reports.vue?vue&type=script&lang=js"
export * from "./inventory-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports